import {
    UPDATE_SUBCATEGORY,
    UPDATE_SUBCATEGORY_FAILURE,

    UPDATE_SUBCATEGORY_LOCALISATION,
    UPDATE_SUBCATEGORY_LOCALISATION_FAILURE,
    UPDATE_SUBCATEGORY_LOCALISATION_SUCCESS,
} from 'store/actions/types';

export const updateSubcategory = (payload) => {
    return {
        type: UPDATE_SUBCATEGORY,
        payload: payload,
    };
};

export const updateSubcategoryFailure = (error) => {
    return {
        type: UPDATE_SUBCATEGORY_FAILURE,
        error: error,
    };
};

export const updateSubcategoryLocalisation = (payload, response) => {
    return {
        type: UPDATE_SUBCATEGORY_LOCALISATION,
        payload: payload,
        response: response,
    };
};

export const updateSubcategoryLocalisationFailure = (error) => {
    return {
        type: UPDATE_SUBCATEGORY_LOCALISATION_FAILURE,
        error: error,
    };
};

export const updateSubcategoryLocalisationSuccess = (payload, response) => {
    return {
        type: UPDATE_SUBCATEGORY_LOCALISATION_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/subcategories/updateSubcategories.js